<template>
  <div :class="['join-us', { 'join-us-1': isJoin }]">
    <div class="title">了解元素魔方</div>
    <div class="content">
      元素魔方致力于构建综合性的科研服务平台，服务全国科研人群<br>
      以分析测试为核心，我们提供材料/化学测试、模拟计算、耗材设备、科研绘图、课题组研究方向等各类科研服务<br>
      加入我们，成为优质供应商，提升仪器设备使用率
    </div>
    <div class="apply-btn" v-if="!isJoin" @click="applySupplier">申请成为供应商</div>
    <div class="apply-btn" v-if="isJoin" @click="goSupplier">登录供应商后台</div>
  </div>
</template>

<script>
import { checkSupplier } from "@/api/user";
export default {
  name: 'UserJoin',
  components: {

  },
  data() {
    return {
      loading: true,
      isJoin: false,
    };
  },
  computed: {

  },
  created() {
    this.checkSupplier();
  },
  methods: {
    checkSupplier() {
      checkSupplier({}).then(res => {
        this.loading = false;
        this.isJoin = res.data;
      }).catch((err) => {

      });
    },
    applySupplier() {
      this.$router.push({
        path: '/auth/register',
        query: {
          type: 1
        }
      });
    },
    goSupplier() {
      window.open('http://test.ylmm-tech.com/supplier/')
    }
  }
};
</script>

<style lang="scss" scoped>
.join-us {
  width: 100%;
  background: #FFFFFF;
  box-shadow: 0px 0px 10px 1px rgba(111, 127, 132, 0.102);
  border-radius: 2px 2px 2px 2px;
  padding-top: 376px;
  padding-bottom: 150px;
  box-sizing: border-box;
  background-image: url(~@/assets/images/join_us_bg.png);
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: 0 0;
  margin-top: 16px;

  .title {
    width: 100%;
    padding-left: 49px;
    margin-bottom: 20px;
    box-sizing: border-box;
    font-size: 16px;
    font-weight: bold;
    color: #00B4E8;
  }

  .content {
    width: 100%;
    padding-left: 49px;
    box-sizing: border-box;
    font-size: 16px;
    font-weight: 300;
    color: #222222;
    line-height: 30px;
    margin-bottom: 68px;
  }

  .apply-btn {
    width: fit-content;
    padding: 10px 51px;
    background: #00B4E8;
    border-radius: 20px;
    font-size: 14px;
    font-weight: 300;
    color: #FFFFFF;
    margin: 0 auto;
    cursor: pointer;
  }
}

.join-us-1 {
  background-image: url(~@/assets/images/join_us_bg1.png) !important;
}
</style>
